import { createComponent } from '@carvana/merch-components';
import { legacyBreakpoints } from '@carvana/merch-tailwind/breakpoints';
import styled from 'styled-components';
import { EpicSection } from '@/vdp/styles';

export const Section = createComponent(EpicSection, {
  className: 'flex flex-col items-center justify-center'
});

export const InnerWrapper = styled.div.attrs({
  className: 'bg-white grid mt-32 p-24 w-fit'
})`
  max-width: 327px;
  grid-template-rows: auto;

  @media (min-width: ${legacyBreakpoints.m}px) {
    max-width: 1144px;
    grid-template-columns: repeat(2, auto);
    grid-template-rows: revert;
  }
`;

export const CardWrapper = createComponent('div', {
  className: 'flex gap-16'
});
